import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import "./topDashboard.scss";
import { GiBookCover } from "react-icons/gi";
import { FaCartShopping } from "react-icons/fa6";
import { FaUser } from "react-icons/fa";
import { GrAnnounce } from "react-icons/gr";
import { AuthContext } from "../../context/AuthContext";
import { Link } from "react-router-dom";

const TopDashboard = () => {
  const { admin } = useContext(AuthContext);
  const [products, setProducts] = useState("");
  const [customer, setCustomer] = useState({});

  const userId = admin._id

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(`/get-all-promotion-number/${userId}`);
        setProducts(response.data)
      } catch (error) {
        return;
      }
    };
    getData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get("/get-all-customers-number");
        setCustomer(response.data);
      } catch (error) {
        return;
      }
    };
    getData();
  }, []);

  const totalCustomer = customer.length;




  return (
    <div className="h_profile_head">
      <Link to={"/promotion"}>
        <div className="h_hed_sec a">
          <span>
            <h4 style={{ color: "rgba(82, 67, 217" }}>{products}</h4>
            <small>My Promotion</small>
          </span>
          <span>
            <div className="h_i_in aa">
              <GrAnnounce size={17} />
            </div>
          </span>
        </div>
      </Link>
      <Link to={"/participants"}>
        <div className="h_hed_sec b">
          <span>
            <h4 style={{ color: "rgba(247, 193, 46)" }}>{totalCustomer}</h4>
            <small>All Participants</small>
          </span>
          <span>
            <div className="h_i_in bb ">
              <FaUser size={17} />
            </div>
          </span>
        </div>{" "}
      </Link>
      {/* <div className="h_hed_sec c">
        <span>
          <h4>200</h4>
          <p>Total Product</p>
        </span>
        <span>
          <div className="h_i_in cc">
            <FaMoneyBillTrendUp size={17} />
          </div>
        </span>
      </div>
      <div className="h_hed_sec d">
        <span>
          <h4>100</h4>
          <p>Total Brand</p>
        </span>
        <span>
          <div className="h_i_in dd">
            <FaMoneyBillTrendUp size={17} />
          </div>
        </span>
      </div> */}
    </div>
  );
};

export default TopDashboard;
